module.exports = __webpack_public_path__ + "static/media/image13.0f09cd97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/preConference/image13.jpg
// module id = 1126
// module chunks = 0